import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { ApiService } from 'app/shared/apis/api.service';
import { of, switchMap, take } from 'rxjs';
import { resolveDriverHomePath } from '../driver-user';
import { resolveRequesterHomePath } from '../requester-user';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
    const router = inject(Router);

    if (!inject(AuthService).check()) {
        return of(true);
    }

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user) => {
            const driverHome = resolveDriverHomePath(user);
            if (driverHome) {
                return of(router.parseUrl(driverHome));
            }
            const requesterHome = resolveRequesterHomePath(user);
            if (requesterHome) {
                return of(router.parseUrl(requesterHome));
            }

            return of(router.parseUrl(''));
        }),
    );
};
